import { APP_CONFIG } from "@shared/config";

export function initFavicon(){
    let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
    }
    link.href = `/images/logo/${APP_CONFIG.appName}_mini.svg`;
}